export function isBuyItNowVisible({ isFeaturedListing, isListingPreorder }: {
  isFeaturedListing: boolean,
  isListingPreorder: boolean,
}) {
  const isVisibleOnListing = !isFeaturedListing;

  return isVisibleOnListing && !isListingPreorder;
}
